import convert from 'convert-units';
import { ImperialUnits, MetricUnits } from '@/lib/unitConversion/unitConversionFactors';
import {IDistribution} from "@/lib/monteCarlo/interfaces";

/**
 * Convert distribution.
 * @param A
 * @param from
 * @param to
 */

export const convertDistributionImperialToMetric = (A: IDistribution, from: ImperialUnits, to: MetricUnits): IDistribution => {

  const B: IDistribution = {
    // TS-Ignore used here to suppress typecheck issue where the enum values aren't recognized as units.

    id: A.id,
    name: A.name,
    prob: A.prob,
    // @ts-ignore
    min: convert(A.min || 0).from(from).to(to),
    // @ts-ignore
    max: convert(A.max || 0).from(from).to(to),
    // @ts-ignore
    mean: convert(A.mean || 0).from(from).to(to),
    // @ts-ignore
    mode: convert(A.mode || 0).from(from).to(to),
    // @ts-ignore
    std: convert(A.std || 0).from(from).to(to),

    // Logspace params
    // @ts-ignore
    location: Math.log(convert(Math.exp(A.location || 0)).from(from).to(to)),
    // @ts-ignore
    // I'm pretty sure not transforming the shape parameter is not exactly correct but it works out pretty darn close.
    shape: A.shape,
  };

  return B;
};


export const convertDistributionMetricToImperial = (A: IDistribution, from: MetricUnits, to: ImperialUnits): IDistribution => {
  const B: IDistribution = {
    // TS-Ignore used here to suppress typecheck issue where the enum values aren't recognized as units.

    id: A.id,
    name: A.name,
    prob: A.prob,
    // @ts-ignore
    min: convert(A.min || 0).from(from).to(to),
    // @ts-ignore
    max: convert(A.max || 0).from(from).to(to),
    // @ts-ignore
    mean: convert(A.mean || 0).from(from).to(to),
    // @ts-ignore
    mode: convert(A.mode || 0).from(from).to(to),
    // @ts-ignore
    std: convert(A.std || 0).from(from).to(to),

    // Logspace params
    // @ts-ignore
    location: Math.log(convert(Math.exp(A.location || 0)).from(from).to(to)),
    // @ts-ignore
    shape: A.shape,
  };

  return B;
};
